import React, { useState } from 'react';

const StepFourScheduling = ({ onNext, onPrevious, formData }) => {
  const [scheduleData, setScheduleData] = useState(formData.stepFourSchedule || {
    preferredDate1: '',
    preferredTime1: '',
    preferredDate2: '',
    preferredTime2: '',
    schedulingNotes: ''
  });

  const timeWindows = [
    "Morning (8 AM - 12 PM)",
    "Afternoon (12 PM - 4 PM)",
    "Evening (4 PM - 8 PM)",
    "Any Time"
  ];

  const handleChange = (e) => {
    const { name, value } = e.target;
    setScheduleData(prev => ({ ...prev, [name]: value }));
  };

  const handleNext = () => {
    // Basic validation: at least first preferred date and time should be selected
    if (!scheduleData.preferredDate1 || !scheduleData.preferredTime1) {
      alert('Please select at least your first preferred date and time window.');
      return;
    }
    onNext({ stepFourSchedule: scheduleData });
  };
  
  // Get today's date for min attribute of date input to prevent past date selection
  const getMinDate = () => {
    const today = new Date();
    const dd = String(today.getDate()).padStart(2, '0');
    const mm = String(today.getMonth() + 1).padStart(2, '0'); // January is 0!
    const yyyy = today.getFullYear();
    return `${yyyy}-${mm}-${dd}`;
  }

  return (
    <div className="space-y-6">
      <h3 className="text-xl font-semibold text-brand-text-dark mb-1">Select Your Preferred Appointment Time</h3>
      <p className="text-sm text-brand-text-light mb-4">Please provide your preferred date(s) and time window(s). We will contact you to confirm the final appointment.</p>

      <div className="p-3 bg-blue-50 border border-blue-200 rounded-md">
        <p className="text-xs text-blue-700">
          <strong>Please note:</strong> Your selected date(s) and time(s) are preferences. 
          A Quality Air of Texas representative will contact you to confirm the final appointment schedule.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-4">
        {/* First Preference */}
        <div>
          <label htmlFor="preferredDate1" className="block text-sm font-medium text-brand-text-light mb-1">Preferred Date <span className="text-red-600">*</span></label>
          <input 
            type="date" 
            name="preferredDate1" 
            id="preferredDate1" 
            value={scheduleData.preferredDate1} 
            onChange={handleChange} 
            min={getMinDate()} 
            className="form-input border-gray-300"
          />
        </div>
        <div>
          <label htmlFor="preferredTime1" className="block text-sm font-medium text-brand-text-light mb-1">Preferred Time Window <span className="text-red-600">*</span></label>
          <select name="preferredTime1" id="preferredTime1" value={scheduleData.preferredTime1} onChange={handleChange} className="form-input border-gray-300">
            <option value="" disabled>Select time window</option>
            {timeWindows.map(tw => <option key={tw} value={tw}>{tw}</option>)}
          </select>
        </div>

        {/* Second Preference (Optional) */}
        <div>
          <label htmlFor="preferredDate2" className="block text-sm font-medium text-brand-text-light mb-1">Alternative Date (Optional)</label>
          <input 
            type="date" 
            name="preferredDate2" 
            id="preferredDate2" 
            value={scheduleData.preferredDate2} 
            onChange={handleChange} 
            min={getMinDate()}
            className="form-input border-gray-300"
          />
        </div>
        <div>
          <label htmlFor="preferredTime2" className="block text-sm font-medium text-brand-text-light mb-1">Alternative Time Window (Optional)</label>
          <select name="preferredTime2" id="preferredTime2" value={scheduleData.preferredTime2} onChange={handleChange} className="form-input border-gray-300">
            <option value="">Select time window</option>
            {timeWindows.map(tw => <option key={tw} value={tw}>{tw}</option>)}
          </select>
        </div>
      </div>

      <div>
        <label htmlFor="schedulingNotes" className="block text-sm font-medium text-brand-text-light mb-1">Scheduling Notes (Optional)</label>
        <textarea 
          name="schedulingNotes" 
          id="schedulingNotes" 
          rows="3" 
          value={scheduleData.schedulingNotes} 
          onChange={handleChange} 
          placeholder="e.g., Please call before arriving, gate code is #1234, any known parking issues, etc."
          className="form-input border-gray-300"
        />
      </div>

      <style jsx>{`
        .form-input {
          @apply mt-1 block w-full p-3 border rounded-md shadow-sm focus:ring-brand-accent focus:border-brand-accent sm:text-sm;
        }
      `}</style>

      <div className="flex justify-between mt-8">
        <button type="button" onClick={onPrevious} className="cta-button-secondary">Previous</button>
        <button type="button" onClick={handleNext} className="cta-button">Next</button>
      </div>
    </div>
  );
};

export default StepFourScheduling; 